const sliderDetail = document.querySelector('.slider--detail');

if (sliderDetail) {
	const swiper = new Swiper(sliderDetail, {
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		loop: true,
		speed: 2200,
		navigation: {
			nextEl: '.slider__detail-next',
			prevEl: '.slider__detail-prev',
		}
	});
}